import { createContext, useEffect, useState } from "react";
import { subscribeToVerifiedUsers } from "../services/firebaseActions/verifiedUsers";
import { useAuth } from "./authProvider";

export const VerifiedUsersContext = createContext();

export const VerifiedUsersProvider = ({ children }) => {
  const [verifiedUsers, setVerifiedUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { isLoggedIn } = useAuth();

  useEffect(() => {
    if (isLoggedIn === null) return;

    if (!isLoggedIn) {
      setVerifiedUsers([]);
      setIsLoading(true);
      return;
    }

    const unsubscribe = subscribeToVerifiedUsers(
      setIsLoading,
      setVerifiedUsers,
    );
    return () => unsubscribe();
  }, [isLoggedIn]);

  return (
    <VerifiedUsersContext.Provider value={{ verifiedUsers, isLoading }}>
      {children}
    </VerifiedUsersContext.Provider>
  );
};
